import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ForOFor from './../container/forOFor';
import ArticleDetail from './articleDetail';
import { fetchArticleDetail } from './../actions.js';
import { saveArticleStats } from './../../ui/src/csm.service.js';
import { getArticle } from './../../ui/src/actions.js';
import { getProp } from '../../ui/src/utilities';

class ArticleContentItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.readTimeout = null;
  }

  componentDidMount() {
    const idFromUrl = this.getUrlId(this.props);
    this.init(idFromUrl || this.props.id);
  }

  componentWillReceiveProps(nextProps) {
    const idFromUrl = this.getUrlId(nextProps);
    if (idFromUrl) {
      // direct access
      if (idFromUrl !== this.getUrlId(this.props)) {
        this.init(idFromUrl);
      }
    } else {
      // indirect access
      if (nextProps.id !== this.props.id) {
        this.init(nextProps.id);
      }
    }
  }

  getUrlId(props) {
    let id = getProp(props, 'params.id', null);
    if (id !== null) {
      return Number(id);
    }
    return null;
  }

  init(id) {
    if (id) {
      this.props.dispatch(getArticle(process.env.REACT_APP_CONTENT_SPACE, id));
      this.props.dispatch(fetchArticleDetail(id));
      clearTimeout(this.readTimeout);
      this.readTimeout = setTimeout(() => {
        saveArticleStats(process.env.REACT_APP_CONTENT_SPACE, id);
      }, 2000);
    }
  }

  render() {
    const idFromUrl = this.getUrlId(this.props);
    const id = idFromUrl || this.props.id;
    if (!id || this.props.isNotFound) {
      return <ForOFor />;
    }
    return <ArticleDetail id={id} />;
  }
}

ArticleContentItem.fetchData = ({ store, renderProps: { params } }) => {
  let id = getProp(params, 'id', null);
  if (id !== null) {
    return store
      .dispatch(getArticle(process.env.REACT_APP_CONTENT_SPACE, id))
      .catch(e => {
        console.error(e);
      });
  }
  return Promise.resolve();
};

ArticleContentItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.number,
  isNotFound: PropTypes.bool,
};

ArticleContentItem.defaultProps = {
  isNotFound: null,
};

export default connect(state => {
  return {
    isNotFound: state.articles.httpStatus === 404,
  };
})(ArticleContentItem);



// WEBPACK FOOTER //
// ./src/app/container/articleContentItem.js